import { ExportColumn } from '../../../../../interfaces/ExportColumn';

export const baseColumns: ExportColumn[] = [
  {
    key: 'firstName',
    header: 'First Name',
    type: 'text',
    width: 30,
  },
  {
    key: 'lastName',
    header: 'Last Name',
    type: 'text',
    width: 30,
  },
  {
    key: 'email',
    header: 'Email',
    type: 'email',
    width: 40,
  },
  {
    key: 'role',
    header: 'Role / Title',
    type: 'text',
  },
  {
    key: 'phone',
    header: 'Phone',
    type: 'number',
    width: 30,
  },
  {
    key: 'backUpFirstName',
    header: 'Back-up First Name',
    type: 'text',
  },
  {
    key: 'backUpLastName',
    header: 'Back-up Last Name',
    type: 'text',
  },
  {
    key: 'backUpEmail',
    header: 'Back-up Email',
    type: 'email',
    width: 40,
  },
  {
    key: 'backUpPhone',
    header: 'Back-up Phone',
    type: 'number',
  },
];
